<div class="component-wrapper g-just-flex p-20" style="box-sizing: border-box;">
    <div style="position: relative;"
        [ngClass]="{'mb50': isChosenOption, 'mb-100': isMultiple.value == 'Multiple' && isChosenOption && formFields && formMetaData}">
        <mat-form-field appearance="outline" floatLabel="always"
            style="display:block; justify-content:center; margin:auto; width:max-content; padding-bottom: 20px;">
            <mat-label>
                Single or Group
            </mat-label>
            <mat-hint>
                Request a Single or Group of Medication Requests.
            </mat-hint>
            <mat-select [formControl]="isMultiple">
                <mat-option value="Single">Single</mat-option>
                <mat-option value="Multiple">Group</mat-option>
            </mat-select>
        </mat-form-field>

        @if(isChosenOption && formFields && formMetaData && !isEditMode){

        <!-- NEW: Actual Medication (ICD-11 search + Stock merge) -->
        <div style="position: relative; width: 100%; margin-bottom: 14px;
        padding:20px; box-sizing: border-box; background-color: var(--mat-sys-surface-container-low); border-radius:8px;
        box-shadow: var(--mat-sys-level-1)
        ">
            <div class="title mb-10">
                Actual Medication
            </div>

            <mat-form-field appearance="outline" floatLabel="always" style="display:block; width: 100%;">
                <mat-label>Actual medication (RxNorm search)</mat-label>

                <input matInput [formControl]="rxNormMedicationCtrl" [matAutocomplete]="icd11Auto"
                    placeholder="Type to search RxNorm..." />

                <!-- @if(rxNormSearching$ | async){ -->
                <span matSuffix style="display:inline-flex; align-items:center;"
                    (click)="rxNormMedicationCtrl.setValue('')">
                    <mat-icon>autorenew</mat-icon>
                </span>
                <!-- } -->

                <mat-autocomplete #icd11Auto="matAutocomplete" [displayWith]="displayRxNormOption">
                    <!-- @for(opt of (rxNormMergedMedicationOptions$ | async) ?? []; track $index){
                    <mat-option [value]="opt">
                        <span [ngClass]="{'g-just-flex': false, 'gap-10': true, 
                            'flexC': opt.kind === 'rxnorm', 'mb-10': opt.kind === 'rxnorm'
                        }" style="align-items:center;">
                            @if(opt.kind === 'rxnorm'){
                            <strong class="brand">
                                {{ opt.display }}
                            </strong>
                            <em class="ms-10">
                                {{opt.ingredients}}
                            </em>
                            }@else{
                            <span>{{ opt.label }}</span>
                            }
                            @if(opt.kind === 'stock'){
                            <em class="mx-10">
                                {{opt.ingredients}}
                            </em>
                            <span [appEmphasis]="'success'" fontSize="11px">in stock</span>
                            } -->
                    @for(opt of (rxNormMergedMedicationOptions$ | async) ?? []; track $index){
                    <mat-option [value]="opt">
                        <!-- {{opt | json}} -->
                        <span [ngClass]="{'g-just-flex':false, 'gap-10': true,
                        'flexC': opt.kind === 'rxnorm', 'mb-10': opt.kind === 'rxnorm'
                    }" style="align-items:center;">
                            @if(opt.kind === 'rxnorm'){
                            <strong class="brand">{{ opt?.label?.display }}</strong>
                            }@else{
                            <span>{{ opt.kind === 'userExactWords' ? 'Use "' : '' }}{{ opt?.label?.display }}
                                {{ opt.kind === 'userExactWords' ? '" as entered' : '' }}
                            </span>
                            }
                            @if(opt?.label?.ingredients){
                            <em class="ms-10">{{ opt.label.ingredients }}</em>
                            }
                            @if(opt.kind === 'stock'){
                            <span [appEmphasis]="'success'" fontSize="11px">in stock</span>
                            }
                        </span>
                    </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>

            <!-- Overlay: covers where the autocomplete dropdown would appear -->
            @if(loading$ | async){
            <div style="
                position: absolute;
                left: 0;
                right: 0;
                top: 100%;
                margin-top: 4px;
                z-index: 1000;
                background: var(--mat-sys-surface, #fff);
                border: 1px solid var(--mat-sys-outline-variant, rgba(0,0,0,0.12));
                border-radius: 6px;
                padding: 12px;
                box-shadow: 0 6px 18px rgba(0,0,0,0.18);
            ">
                <div class="g-just-flex gap-10" style="align-items:center;">
                    <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                    <span>Searching RxNorm…</span>
                </div>
            </div>
            }
        </div>

        <div id="medication-form-top"></div>
        <app-dynamic-forms-v2 [formFields]="formFields" [formMetaData]="formMetaData"
            (formSubmitted)="processValues($event)" #cref>
        </app-dynamic-forms-v2>

        }
        @if(isMultiple.value == 'Multiple' && isChosenOption && formFields && formMetaData && !isEditMode){
        <!-- A "request more test and finish-OR-WHATEVER IS APPROPPRIATE" button LOCATED TO THE END OF THE CONTAINER WITH 40PX GAP -->
        <form [formGroup]="requestForm" class="mt-30">
            <div formArrayName="items">
                @for(group of items.controls; track $index) {
                <div [formGroupName]="$index" class="one-request mb-30" [id]="'review-item-' + $index">
                    <!--remove button -->
                    <button mat-icon-button color="warn" (click)="removeRequest($index)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <app-resource-data-review [resource]="group.value" [formFields]="formFields"
                        [submittedData]="group.value" (fieldEdited)="onFieldEdited($index, $event)"
                        (resourceUpdated)="onResourceUpdated($index, $event)" [showEditButtons]="true">
                    </app-resource-data-review>
                </div>
                }
            </div>
        </form>
        <div class="g-just-flex gap-30 justify-content-end mt-20 dactions flex-wrap">

            @if(requestForm && requestForm.valid && items && items.length > 0 ){
            <button mat-stroked-button type="button" (click)="scrollToForm()">
                <mat-icon>arrow_upward</mat-icon> Add Another Request
            </button>
            <button mat-flat-button (click)="submitAllRequests()">
                <mat-icon>check</mat-icon>
                <span>Submit All</span>
            </button>

            }
        </div>


        }@else{ }

        @if(isEditMode && formFields && formMetaData && submittedData){
        <app-resource-data-review [formFields]="formFields!" [resource]="editingMedicationRequest"
            [submittedData]="submittedData" (fieldEdited)="onEditField($event)"
            (resourceUpdated)="onEditResource($event)" [showEditButtons]="true">
        </app-resource-data-review>

        <div class="g-just-flex gap-30 justify-content-end mt-20 dactions flex-wrap">
            <button mat-flat-button (click)="submitEdit()">
                <mat-icon>check</mat-icon>
                <span>Save</span>
            </button>
        </div>
        }

        <!-- @if(!isEditMode && formFields && formMetaData){
  <form [formGroup]="requestForm" class="mt-30">
    <div formArrayName="items">
      @for(group of items.controls; track $index) {
        <div [formGroupName]="$index" class="one-request mb-30">
          <app-resource-data-review
            [resource]="group.value"
            [formFields]="formFields!"
            [submittedData]="group.value"
            (fieldEdited)="onFieldEdited($index, $event)"
            (resourceUpdated)="onResourceUpdated($index, $event)"
            [showEditButtons]="true">
          </app-resource-data-review>
        </div>
      }
    </div>
  </form>

  <div class="g-just-flex gap-30 justify-content-end mt-20 dactions flex-wrap">
    @if(requestForm && requestForm.valid && items && items.length > 0 ){
      <button mat-flat-button (click)="submitAllRequests()">
        <mat-icon>check</mat-icon>
        <span>Submit All</span>
      </button>
    }
  </div>
} -->

    </div>

</div>
<!-- {{toSubmitFinally || {} | json}} -->